import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
  CanActivateFn,
} from '@angular/router';
import { inject } from '@angular/core';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const router = inject(Router);
  if (localStorage['accessToken']) {
    return true;
  } else {
    return router.createUrlTree(['/login']);
  }
};

export const UnAuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const router = inject(Router);
  if (!localStorage['accessToken']) {
    return true;
  } else {
    if (localStorage['roleId'] === '3' || localStorage['roleId'] === '4') {
      return router.createUrlTree(['/new-dashboard']);
    }
    return router.createUrlTree(['/dashboard']);
  }
};

export const RoleSelectGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const router = inject(Router);
  if (localStorage['status'] === '3') {
    return true;
  } else {
    return router.createUrlTree(['/role-select']);
  }
};

export const NonRoleSelectGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const router = inject(Router);
  if (localStorage['status'] === '1') {
    return true;
  } else {
    if (localStorage['roleId'] === '3') {
      return router.createUrlTree(['/new-dashboard']);
    }
    return router.createUrlTree(['/dashboard']);
  }
};

export const UserGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const router = inject(Router);
  if (localStorage['roleId'] !== '1') {
    return true;
  } else {
    return router.createUrlTree(['/dashboard']);
  }
};

export const AdminGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const router = inject(Router);
  if (localStorage['roleId'] === '1') {
    return true;
  } else {
    if (localStorage['roleId'] === '3') {
      return router.createUrlTree(['/new-dashboard']);
    }
    return router.createUrlTree(['/dashboard']);
  }
};

export const StudentGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const router = inject(Router);
  if (localStorage['roleId'] === '3') {
    return true;
  } else {
    return router.createUrlTree(['/dashboard']);
  }
};

export const AdminOrTutorGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const router = inject(Router);
  if (localStorage['roleId'] === '1' || localStorage['roleId'] === '2') {
    return true;
  } else {
    return router.createUrlTree(['/new-dashboard']);
  }
};

// @Injectable({ providedIn: "root" })
// export class AuthGuard implements CanActivate {
//   constructor(private router: Router) {}
//   canActivate(
//     route: ActivatedRouteSnapshot,
//     router: RouterStateSnapshot
//   ): boolean | UrlTree {
//     if (localStorage.accessToken) {
//       return true;
//     } else {
//       return this.router.createUrlTree(["/login"]);
//     }
//   }
// }

// @Injectable({ providedIn: "root" })
// export class UnAuthGuard implements CanActivate {
//   constructor(private router: Router) {}
//   canActivate(
//     route: ActivatedRouteSnapshot,
//     router: RouterStateSnapshot
//   ): boolean | UrlTree {
//     if (!localStorage.accessToken) {
//       return true;
//     } else {
//       return this.router.createUrlTree(["/dashboard"]);
//     }
//   }
// }

// @Injectable({ providedIn: "root" })
// export class RoleSelectGuard implements CanActivate {
//   constructor(private router: Router) {}
//   canActivate(
//     route: ActivatedRouteSnapshot,
//     router: RouterStateSnapshot
//   ): boolean | UrlTree {
//     if (localStorage.status === "3") {
//       return true;
//     } else {
//       return this.router.createUrlTree(["/role-select"]);
//     }
//   }
// }

// @Injectable({ providedIn: "root" })
// export class NonRoleSelectGuard implements CanActivate {
//   constructor(private router: Router) {}
//   canActivate(
//     route: ActivatedRouteSnapshot,
//     router: RouterStateSnapshot
//   ): boolean | UrlTree {
//     if (localStorage.status === "1") {
//       return true;
//     } else {
//       return this.router.createUrlTree(["/dashboard"]);
//     }
//   }
// }

// @Injectable({ providedIn: "root" })
// export class AdminGuard implements CanActivate {
//   constructor(private router: Router) {}
//   canActivate(
//     route: ActivatedRouteSnapshot,
//     router: RouterStateSnapshot
//   ): boolean | UrlTree {
//     if (localStorage.roleId === "1") {
//       return true;
//     } else {
//       return this.router.createUrlTree(["/dashboard"]);
//     }
//   }
// }

// @Injectable({ providedIn: "root" })
// export class AdminOrTutorGuard implements CanActivate {
//   constructor(private router: Router) {}
//   canActivate(
//     route: ActivatedRouteSnapshot,
//     router: RouterStateSnapshot
//   ): boolean | UrlTree {
//     if (localStorage.roleId === "1" || localStorage.roleId === "2") {
//       return true;
//     } else {
//       return this.router.createUrlTree(["/dashboard"]);
//     }
//   }
// }

// @Injectable({ providedIn: "root" })
// export class UserGuard implements CanActivate {
//   constructor(private router: Router) {}
//   canActivate(
//     route: ActivatedRouteSnapshot,
//     router: RouterStateSnapshot
//   ): boolean | UrlTree {
//     if (localStorage.roleId !== "1") {
//       return true;
//     } else {
//       return this.router.createUrlTree(["/dashboard"]);
//     }
//   }
// }

// @Injectable({ providedIn: "root" })
// export class StudentGuard implements CanActivate {
//   constructor(private router: Router) {}
//   canActivate(
//     route: ActivatedRouteSnapshot,
//     router: RouterStateSnapshot
//   ): boolean | UrlTree {
//     if (localStorage.roleId === "3") {
//       return true;
//     } else {
//       return this.router.createUrlTree(["/dashboard"]);
//     }
//   }
// }
